<template>
	<div class="tinymce-editor">
		<!-- 图片上传组件辅助，组件内添加v-show=“false”属性，把该组件隐藏起来。-->
		<el-upload
			v-show="false"
			class="avatar-uploader"
			:action="uploadUrl"
			name="img"
			:show-file-list="false"
			:on-success="uploadSuccess"
			:before-upload="beforeUpload"
		></el-upload>
		<quill-editor ref="QuillEditor" v-model="myValue" class="myQuillEditor" :options="editorOption" />
	</div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

// import { MessageUploadFile } from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	components: {
		quillEditor
	},
	props: {
		//传入一个value，使组件支持v-model绑定
		value: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		plugins: {
			type: [String, Array],
			default: 'lists image media table textcolor wordcount contextmenu preview'
		},
		toolbar: {
			type: [String, Array],
			default:
				'undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image media table | removeformat table'
		}
	},
	data() {
		return {
			editorOption: {
				modules: {
					toolbar: {
						container: [
							['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
							['blockquote', 'code-block'], // 引用  代码块
							[{ header: 1 }, { header: 2 }], // 1、2 级标题
							[{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
							[{ script: 'sub' }, { script: 'super' }], // 上标/下标
							[{ indent: '-1' }, { indent: '+1' }], // 缩进
							[{ direction: 'rtl' }], // 文本方向
							[{ size: ['12', '14', '16', '18', '20', '22', '24', '28', '32', '36'] }], // 字体大小
							[{ header: [1, 2, 3, 4, 5, 6] }], // 标题
							[{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
							// [{ font: ['songti'] }], // 字体种类
							[{ align: [] }], // 对齐方式
							['clean'], // 清除文本格式
							['image', 'video'] // 链接、图片、视频
						],
						handlers: {
							image: function(value) {
								if (value) {
									// 调用element的图片上传组件
									document.querySelector('.avatar-uploader input').click();
								} else {
									this.quill.format('image', false);
								}
							}
						}
					}
				}
			},
			uploadUrl: window.myURL.URL + '/Message/UploadFile',
			myValue: this.value //富文本的内容
		};
	},
	mounted() {
		// console.log('还没initi', this.myValue);
	},
	methods: {
		// 失去焦点
		onEditorBlur(editor) {},
		// 获得焦点
		onEditorFocus(editor) {},
		// 开始
		onEditorReady(editor) {},
		// 值发生变化
		onEditorChange(editor) {
			this.content = editor.html;
			console.log(editor);
		},
		beforeUpload(file) {
			console.log(file, '获取文件信息');
		},
		uploadSuccess(res) {
			// 获取富文本组件实例
			let quill = this.$refs.QuillEditor.quill;
			// 如果上传成功
			console.log(res.data.url, '获取内容11111');
			if (res.code === 1 && res.data) {
				// 获取光标所在位置
				let length = quill.getSelection().index;
				// 插入图片，res为服务器返回的图片链接地址
				quill.insertEmbed(length, 'image', res.data.url);
				// 调整光标到最后
				quill.setSelection(length + 1);
			} else {
				// 提示信息，需引入Message
				this.$message.error('图片插入失败！');
			}
		},
		//添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
		//需要什么事件可以自己增加
		// onClick(e) {
		//   this.$emit('onClick', e, tinymce)
		// },
		//可以添加一些自己的自定义事件，如清空内容
		clear() {
			this.myValue = '';
		}
	},
	watch: {
		value(newValue) {
			this.myValue = newValue;
		},
		myValue(newValue) {
			this.$emit('input', newValue);
		}
	}
};
</script>
<style scoped>
.tinymce-editor {
	height: 500px;
}
.myQuillEditor {
	height: 78%;
}
</style>
